import { useNavigation } from "contexts/Navigation"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"
import { surtitle50, headline30, bold } from "css/text"

import Image from "../media/ImageCLD"

const A = styled.a`
  display: block;
  position: relative;
  width: 100%;
  text-decoration: none;

  & * {
    pointer-events: none;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover img {
      transform: scale(1.05) translate3d(0, 0, 0);
    }
  }
`

const Figure = styled.figure`
  width: 100%;

  & img {
    display: block;
    width: 100%;
    height: auto;
    transform: scale(1) translate3d(0, 0, 0);
    transition: transform 0.4s ease-out;
  }
`

const Container = styled.div`
  overflow: hidden;
`

const Caption = styled.figcaption`
  margin-block-start: 15px;
  width: calc(100% - 20px);
`

const Title = styled.h3`
  ${headline30}
  ${bold}
  display: block;
  color: white;
`

const Kicker = styled.span`
  ${surtitle50};
  display: block;
  color: white;
`

export default function ExploCard({ image_cld: image, url, heading }) {
  const console = useConsole()
  const navigation = useNavigation()

  const navigate = e => {
    e.preventDefault()
    navigation.navigate(e.target.getAttribute("href"))
  }

  console.verbose("ExploCard(%o)", { url })
  return (
    <A href={navigation.localize(url ?? "#")} onClick={navigate}>
      <Figure>
        <Container>
          <Image {...image} sizes='(min-width: 48rem) 35vw, 70vw' />
        </Container>
        {heading.kicker || heading.title ? (
          <Caption>
            {heading.kicker && <Kicker>{heading.kicker}</Kicker>}
            {heading.title && <Title>{heading.title}</Title>}
          </Caption>
        ) : null}
      </Figure>
    </A>
  )
}
